import React from 'react';

export default function ContentPaper({ children, style, className = '' }) {
  return (
    <div className={`vi-paper ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}